import { jsx as m, Fragment as h, jsxs as d } from "react/jsx-runtime";
import { forwardRef as u, useCallback as x } from "react";
import { Paragraph as y } from "../../../atoms/Paragraph/Paragraph.es.js";
import { Avatar as l } from "../../../atoms/Avatar/Avatar.es.js";
import { Highlight as j } from "@chakra-ui/react";
import "../../../icons/index.es.js";
import "../../../atoms/Button/Button.es.js";
import "../../Dropdown/Dropdown.context.es.js";
import { DropdownItem as w } from "../../Dropdown/components/DropdownItem.es.js";
import "../../Dropdown/Dropdown.container.es.js";
const q = u(
  ({ options: n, query: s = "", onClickOption: i }, z) => {
    const f = x(
      (o) => {
        i(o);
      },
      [i]
    );
    return /* @__PURE__ */ m(h, { children: n.map(({ avatar: o, id: t, isDisabled: e, label: r, trackId: p, value: c }, g) => /* @__PURE__ */ d(
      w,
      {
        isDisabled: e,
        onClick: () => f({ avatar: o, id: t, isDisabled: e, label: r, trackId: p, value: c }),
        trackId: p,
        children: [
          o && /* @__PURE__ */ m(
            l,
            {
              src: typeof o == "string" ? o : o.src,
              name: typeof o == "string" ? r : o.name,
              alt: typeof o == "string" ? r : o.name,
              size: "xs"
            }
          ),
          /* @__PURE__ */ m(y, { size: "md", as: "span", children: /* @__PURE__ */ m(
            j,
            {
              styles: {
                fontWeight: "medium",
                padding: 0
              },
              query: s,
              children: r
            }
          ) })
        ]
      },
      t ?? `${r}-${g}`
    )) });
  }
);
export {
  q as AutocompleteOptions
};
//# sourceMappingURL=AutocompleteOptions.es.js.map
